export default "__VITE_ASSET__60eed736__"